import * as React from 'react';
import Spinner from 'shared/components/hawksearch/components/ui/Spinner';
import { useHawkSearch } from '../../StoreProvider';
import { renderBanner } from './Banner';

function CategoryLandingBanner() {
	const {
		store: { isLoading, searchResults },
	} = useHawkSearch();

	const bannerImage = searchResults?.PageHeading != null ? searchResults.PageHeading : null;
	const bannerPageHeading = searchResults?.Name != null ? searchResults?.Name : null;

	if (isLoading) {
		return <Spinner isVisible={isLoading} />;
	} else {
		return renderBanner(bannerImage, bannerPageHeading);
	}
}

export default CategoryLandingBanner;
